import type React from 'react';

import { ButtonGroup, FormField, Label } from '@zillow/constellation';

type Props = {
  children: React.ReactNode;
};

export default function SmokingButtonGroup({ children }: Props) {
  return (
    <FormField
      label={<Label size="lg">Is smoking allowed on the property?</Label>}
      control={
        <ButtonGroup fluid direction="column" aria-label="smoking location" conjoined>
          {children}
        </ButtonGroup>
      }
    />
  );
}
